import { Icon } from './Icon';
import './UploadCta.css';

// Arrow rising out of a tray. The arrow is its own path so CSS can loop it upwards.
function UploadGlyph() {
    return (
        <svg className="addCtaGlyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path className="addCtaGlyphArrow" d="M12 15V4M7 8.5l5-5 5 5" />
            <path d="M4.5 15.5V18A2.5 2.5 0 0 0 7 20.5h10a2.5 2.5 0 0 0 2.5-2.5v-2.5" />
        </svg>
    );
}

// `disabled` keeps the button clickable (so the page can still ask for login first) but quiet.
export function UploadCta({ label, onClick, disabled = false, className = '' }) {
    return (
        <button type="button" className={`addCta ${className}`} onClick={onClick} aria-disabled={disabled || undefined}>
            <span className="addCtaClip" aria-hidden="true"><i className="addCtaShine" /></span>
            <span className="addCtaIcon"><UploadGlyph /></span>
            <span className="addCtaLabel">{label}</span>
            <span className="addCtaArrow"><Icon name="arrowRight" size={18} strokeWidth={2.6} /></span>
        </button>
    );
}
